export default "__VITE_ASSET__CAPTJDwk__"